import {Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {NavService} from '../../../shared/service/nav.service';
import {CreatorService} from '../../../shared/service/creator.service';
import {AuthService} from '../../../shared/service/auth.service';
import {StudentService} from '../../../shared/service/student.service';
import {ClassService} from '../../../shared/service/class.service';
import {ToastrService} from 'ngx-toastr';
import {DatePipe} from '@angular/common';
import {dateOptions, timeZone} from '../../../shared/data/config';
import {urls} from '../../../shared/utils/urls';
import {SessionConstants} from '../../../shared/data/sessionConstants';
export type ProfileTab = 'profile' | 'classes' | 'attendance' | 'reports' | 'curriculum' | 'communications';
export type ProfileInfoSubTab = 'personal' | 'parent';

@Component({
    selector: 'app-student-overall-profile-details-new',
    templateUrl: './student-overall-profile-details-new.component.html',
    styleUrls: ['./student-overall-profile-details-new.component.scss']
})
export class StudentOverallProfileDetailsNewComponent implements OnInit, OnDestroy {

    activeTab: ProfileTab = 'profile';
    profileSubTab: ProfileInfoSubTab = 'personal';
    selectedParent = 1;

    curriculumClassFilterOptions: { class_id: string; class_name: string }[] = [
        {class_id: '', class_name: 'All Class'}
    ];
    selectedClassId = '';
    selectedCurriculumClassId = '';
    curriculumContentTypeFilter = 'All';

    readonly curriculumContentTypeOptions = [
        {value: 'All', label: 'All'},
        {value: '1', label: 'Resource'},
        {value: '2', label: 'Assignment'},
        {value: '3', label: 'Assessment'}
    ];

    attendanceListData: any[] = [];

    selectedReportsClassCode = '';
    reportsContentTypeFilter = 'All';

    allReports: any[] = [];
    reportsListData: any[] = [];
    reportsCurrentPage = 1;
    readonly reportsPageSize = 10;
    readonly reportsMaxPagesToShow = 5;

    protected allCurriculum = [];
    curriculumListData: any = [...this.allCurriculum];
    curriculumCurrentPage = 1;
    readonly curriculumPageSize = 10;
    readonly curriculumMaxPagesToShow = 5;

    protected communicationsData: any[] = [];

    public classData: any;
    public studentId: any;
    public voidClassData: any = {};
    public voidClassIndex = 0;
    modalRef: NgbModalRef;

    readonly curriculumThumb = 'assets/images/ristaschool/option-writing-checkbox-concepts-survey.png';

    readonly personalInfoGroups = [
        {
            title: 'Basic Information',
            icon: 'fa-id-card-o',
            fields: [
                {label: 'First Name', valueKey: 'first_name', capitalize: true},
                {label: 'Last Name', valueKey: 'last_name', capitalize: true},
                {label: 'Gender', valueKey: 'gender', capitalize: true},
                {label: 'Date of Birth', valueKey: 'birthday'},
                {label: 'Grade', valueKey: 'grade_name'},
                {label: 'Student ID', valueKey: 'school_idno'}
            ]
        },
        {
            title: 'Contact & Account',
            icon: 'fa-envelope-o',
            fields: [
                {label: 'Email Address', valueKey: 'email_id'},
                {label: 'Contact Number', valueKey: 'mobile0'},
                {label: 'Contact Number 2', valueKey: 'mobile1'},
                {label: 'Contact Number 3', valueKey: 'mobile2'},
                {label: 'Status', valueKey: 'status', highlight: 'success'},
                {label: 'Registration Date', valueKey: 'registration_date'}
            ]
        },
        {
            title: 'Other',
            icon: 'fa-camera',
            fields: [
                {label: 'Profile Photo', valueKey: 'profile_photo'}
            ]
        }
    ];

    @ViewChild('viewoveralldetails') viewoveralldetails: TemplateRef<any>;
    @ViewChild('viewStudentDetails') viewStudentDetails: TemplateRef<any>;
    @ViewChild('voidClass') voidClass: TemplateRef<any>;

    reportContentId: any;
    reportContentFormat: any;
    reportClassId: any;
    reportStudentContentId: any;
    reportIsTest = '0';

    protected auth = inject(AuthService);
    private student = inject(StudentService);
    private classes = inject(ClassService);
    private toastr = inject(ToastrService);
    private datePipe = inject(DatePipe);
    private gradeData: any[] = [];
    protected studentProfileDetails: any[] = [];
    protected studentFullClassListData: any[] = [];
    protected classList: any[] = [];
    protected serviceCalled = false;
    public studentContentId: any;
    public is_test = '0';
    constructor(private modalService: NgbModal, public router: Router, public navServices: NavService,
                public creatorService: CreatorService) {
        this.studentId = JSON.parse(this.auth.getSessionData('student-profile-details')).user_id;
        this.studentDetails();
    }

    ngOnInit(): void {
        this.creatorService.changeViewList(true);
        this.navServices.collapseSidebar = true;
        this.loadProfileDetailsState();
        this.loadActiveTabData();
    }

    ngOnDestroy(): void {
        this.creatorService.changeViewList(false);
        this.navServices.collapseSidebar = false;
    }

    setTab(tab: ProfileTab): void {
        this.activeTab = tab;
        this.saveProfileDetailsState();
        this.loadActiveTabData();
    }

    setProfileSubTab(tab: ProfileInfoSubTab): void {
        this.profileSubTab = tab;
        this.saveProfileDetailsState();
    }

    parentTabChange(id: number): void {
        this.selectedParent = id;
        this.saveProfileDetailsState();
    }

    private getProfileStateStorageKey(): string {
        return `${this.studentId}_${this.auth.getSessionData('school_id')}`;
    }

    private loadProfileDetailsState(): void {
        const raw = this.auth.getSessionData(SessionConstants.studentProfileDetailsNewSearch);
        if (!raw) {
            return;
        }
        let data: any[];
        try {
            data = JSON.parse(raw);
        } catch {
            return;
        }
        if (!Array.isArray(data)) {
            return;
        }
        const state = data.find((item) => item.storage_key === this.getProfileStateStorageKey());
        if (!state) {
            return;
        }
        const validTabs: ProfileTab[] = ['profile', 'classes', 'attendance', 'reports', 'curriculum', 'communications'];
        if (validTabs.includes(state.activeTab)) {
            this.activeTab = state.activeTab;
        }
        if (state.profileSubTab === 'personal' || state.profileSubTab === 'parent') {
            this.profileSubTab = state.profileSubTab;
        }
        this.selectedParent = state.selectedParent === 2 ? 2 : 1;
        this.selectedClassId = state.selectedClassId ?? '';
        this.selectedCurriculumClassId = state.selectedCurriculumClassId ?? '';
        this.curriculumContentTypeFilter = state.curriculumContentTypeFilter ?? 'All';
        this.curriculumCurrentPage = Number(state.curriculumCurrentPage) || 1;
        this.selectedReportsClassCode = state.selectedReportsClassCode ?? '';
        this.reportsContentTypeFilter = state.reportsContentTypeFilter ?? 'All';
        this.reportsCurrentPage = Number(state.reportsCurrentPage) || 1;
    }

    private saveProfileDetailsState(): void {
        const state = {
            storage_key: this.getProfileStateStorageKey(),
            student_id: String(this.studentId),
            school_id: this.auth.getSessionData('school_id'),
            activeTab: this.activeTab,
            profileSubTab: this.profileSubTab,
            selectedParent: this.selectedParent,
            selectedClassId: this.selectedClassId,
            selectedCurriculumClassId: this.selectedCurriculumClassId,
            curriculumContentTypeFilter: this.curriculumContentTypeFilter,
            curriculumCurrentPage: this.curriculumCurrentPage,
            selectedReportsClassCode: this.selectedReportsClassCode,
            reportsContentTypeFilter: this.reportsContentTypeFilter,
            reportsCurrentPage: this.reportsCurrentPage,
        };
        let data: any[] = [];
        const raw = this.auth.getSessionData(SessionConstants.studentProfileDetailsNewSearch);
        if (raw) {
            try {
                data = JSON.parse(raw);
                if (!Array.isArray(data)) {
                    data = [];
                }
            } catch {
                data = [];
            }
        }
        const index = data.findIndex((item) => item.storage_key === state.storage_key);
        if (index >= 0) {
            data[index] = state;
        } else {
            data.push(state);
        }
        this.auth.setSessionData(SessionConstants.studentProfileDetailsNewSearch, JSON.stringify(data));
    }

    private loadActiveTabData(): void {
        if (this.activeTab === 'curriculum') {
            this.getCurriculumList();
        } else if (this.activeTab === 'communications') {
            this.getCommunicationList();
        } else if (this.activeTab === 'attendance' && this.classList.length) {
            this.attendanceList(this.selectedClassId || '');
        }
    }

    private clampCurriculumPage(): void {
        if (this.curriculumCurrentPage > this.curriculumTotalPages) {
            this.curriculumCurrentPage = this.curriculumTotalPages || 1;
        }
        if (this.curriculumCurrentPage < 1) {
            this.curriculumCurrentPage = 1;
        }
    }

    get profileAvatar(): string {
        const profile = this.studentProfileDetails[0];
        if (profile?.profile_thumb_url) {
            return profile.profile_thumb_url;
        }
        if (profile?.profile_url) {
            return profile.profile_url;
        }
        return 'assets/images/ristaschool/option-writing-checkbox-concepts-survey.png';
    }

    getCurriculumList() {
        const payload = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            student_id: this.studentId,
        };
        this.auth.postService(payload, urls.curriculumList).subscribe((successData: any) => {
            if (successData.IsSuccess) {
                console.log(successData, 'successData');
                this.allCurriculum = successData.ResponseObject.length != 0 ? successData.ResponseObject : [];
                this.enrichCurriculumItems(this.allCurriculum);
                this.buildCurriculumClassFilterOptions(this.allCurriculum);
                this.applyCurriculumFilters(false);
                this.clampCurriculumPage();
                this.saveProfileDetailsState();
            } else {
                this.allCurriculum = [];
                this.curriculumClassFilterOptions = [{class_id: '', class_name: 'All Class'}];
                this.curriculumListData = [];
            }
        }, (error => console.error(error, 'curriculumList_error')));
    }

    getCommunicationList() {
        const payload = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            student_id: this.studentId,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
        this.auth.postService(payload, urls.feedback).subscribe((successData: any) => {
            if (successData.IsSuccess) {
                this.communicationsData = successData.ResponseObject.length != 0 ? successData.ResponseObject : [];
                console.log(successData, 'successData_communication');
            } else {
                this.communicationsData = [];
            }
        }, (error => console.error(error, 'communicationList_error')));
    }

    getStudentFieldValue(key: string): string {
        if (!this.serviceCalled || !this.studentProfileDetails?.length) {
            return '-';
        }
        const s = this.studentProfileDetails[0];
        switch (key) {
            case 'mobile0':
                return s.mobile?.[0] !== '' && s.mobile?.[0] != null ? s.mobile[0] : '-';
            case 'mobile1':
                return s.mobile?.[1] !== '' && s.mobile?.[1] != null ? s.mobile[1] : '-';
            case 'mobile2':
                return s.mobile?.[2] !== '' && s.mobile?.[2] != null ? s.mobile[2] : '-';
            case 'first_name':
                return s.first_name !== '' ? s.first_name : '-';
            case 'last_name':
                return s.last_name !== '' ? s.last_name : '-';
            case 'email_id':
                return s.email_id !== '' ? s.email_id : '-';
            case 'gender':
                return s.gender !== '' ? s.gender : '-';
            case 'birthday':
                return s.birthday !== '0000-00-00' && s.birthday ? this.datePipe.transform(s.birthday, 'MM/dd/yyyy') : '-';
            case 'grade_name':
                return s.grade_id !== '0' && s.grade_id ? (s.grade_name || '-') : '-';
            case 'school_idno':
                return s.school_idno !== '' ? s.school_idno : '-';
            case 'status':
                return this.formatStudentStatus(s.status);
            case 'registration_date':
                return s.registration_date !== '0000-00-00' && s.registration_date
                    ? this.datePipe.transform(s.registration_date, 'MM/dd/yyyy') : '-';
            case 'profile_photo':
                return s.profile_url !== '' ? 'Available' : 'Not-Available';
            default:
                return s[key] ?? '-';
        }
    }

    getParentFieldValue(key: string): string {
        if (!this.serviceCalled || !this.studentProfileDetails?.length) {
            return '-';
        }
        const s = this.studentProfileDetails[0];
        const p = this.selectedParent;
        const addr = s.address?.[p - 1];
        switch (key) {
            case 'first_name':
                return s['parent' + p + '_firstname'] !== '' ? s['parent' + p + '_firstname'] : '-';
            case 'last_name':
                return s['parent' + p + '_lastname'] && s['parent' + p + '_lastname'] !== ''
                    ? s['parent' + p + '_lastname'] : '-';
            case 'email1':
                return s['parent' + p + '_email_ids']?.[0] !== '' ? s['parent' + p + '_email_ids'][0] : '-';
            case 'email2':
                return s['parent' + p + '_email_ids']?.[1] !== '' ? s['parent' + p + '_email_ids'][1] : '-';
            case 'address1':
                return addr?.address1 !== '' ? addr.address1 : '-';
            case 'address2':
                return addr?.address2 !== '' ? addr.address2 : '-';
            case 'city':
                return addr?.city !== '' ? addr.city : '-';
            case 'state_name':
                return addr?.state_name !== '' ? addr.state_name : '-';
            case 'country_name':
                return addr?.country_name !== '' ? addr.country_name : '-';
            case 'postal_code':
                return addr?.postal_code !== '' ? addr.postal_code : '-';
            default:
                return '-';
        }
    }

    readonly parentInfoGroups = [
        {
            title: 'Parent / Guardian',
            icon: 'fa-users',
            fields: [
                {label: 'First Name', key: 'first_name', capitalize: true},
                {label: 'Last Name', key: 'last_name', capitalize: true},
                {label: 'Email Address 1', key: 'email1'},
                {label: 'Email Address 2', key: 'email2'}
            ]
        },
        {
            title: 'Address',
            icon: 'fa-map-marker',
            fields: [
                {label: 'Address 1', key: 'address1', capitalize: true},
                {label: 'Address 2', key: 'address2', capitalize: true},
                {label: 'City', key: 'city', capitalize: true},
                {label: 'State', key: 'state_name', capitalize: true},
                {label: 'Country', key: 'country_name', capitalize: true},
                {label: 'Zip Code', key: 'postal_code'}
            ]
        }
    ];

    formatStudentStatus(status: string | number): string {
        if (status === '1' || status === 1) {
            return 'Active';
        }
        if (status === '2' || status === 2) {
            return 'Suspended';
        }
        if (status === '3' || status === 3) {
            return 'Disengaged';
        }
        if (status === '4' || status === 4) {
            return 'Deleted';
        }
        if (status === 'Active' || status === 'Suspended' || status === 'Disengaged' || status === 'Deleted') {
            return status;
        }
        return '-';
    }

    backFunction(): void {
        this.router.navigate(['/users/user-list']);
    }
    private resolveClassName(classId: string): string | undefined {
        return this.curriculumClassFilterOptions.find(c => c.class_id === classId)?.class_name;
    }

    viewReportDetail(report: any): void {
        this.reportContentId = report.content_id;
        this.reportContentFormat = report.content_format;
        this.reportClassId = report.class_id;
        this.reportStudentContentId = report.student_content_id;
        this.reportIsTest = report.is_test ?? '0';
        this.modalRef = this.modalService.open(this.viewStudentDetails, {size: 'xl', windowClass: 'reportcardContent'});
    }

    closeReportDetail(): void {
        this.modalRef.close('viewStudentDetails');
    }

    curriculumClassFilter(value: { class_id: string; class_name: string } | string | null): void {
        let classId = '';
        if (value && typeof value === 'object') {
            classId = value.class_id ?? '';
        } else if (typeof value === 'string') {
            classId = value;
        }
        this.selectedCurriculumClassId = classId;
        this.applyCurriculumFilters();
    }

    onCurriculumContentTypeChange(): void {
        this.applyCurriculumFilters();
    }

    applyCurriculumFilters(resetPage = true): void {
        let list = [...this.allCurriculum];
        if (this.selectedCurriculumClassId !== '') {
            list = list.filter(c => c.class_id === this.selectedCurriculumClassId);
        }
        if (this.curriculumContentTypeFilter !== 'All') {
            list = list.filter(c => c.content_type === this.curriculumContentTypeFilter);
        }
        this.curriculumListData = list;
        if (resetPage) {
            this.curriculumCurrentPage = 1;
        }
        this.saveProfileDetailsState();
    }

    get curriculumTotalPages(): number {
        return Math.ceil(this.curriculumListData.length / this.curriculumPageSize) || 1;
    }

    get curriculumPaginatedItems(): any[] {
        const startIndex = (this.curriculumCurrentPage - 1) * this.curriculumPageSize;
        return this.curriculumListData.slice(startIndex, startIndex + this.curriculumPageSize);
    }

    get curriculumPages(): number[] {
        const totalPages = this.curriculumTotalPages;
        const currentPage = this.curriculumCurrentPage;
        const maxPagesToShow = this.curriculumMaxPagesToShow;

        if (totalPages <= maxPagesToShow) {
            return Array.from({length: totalPages}, (_, i) => i + 1);
        }
        let startPage: number;
        let endPage: number;
        if (currentPage <= Math.ceil(maxPagesToShow / 2)) {
            startPage = 1;
            endPage = maxPagesToShow;
        } else if (currentPage + Math.floor(maxPagesToShow / 2) >= totalPages) {
            startPage = totalPages - maxPagesToShow + 1;
            endPage = totalPages;
        } else {
            startPage = currentPage - Math.floor(maxPagesToShow / 2);
            endPage = currentPage + Math.floor(maxPagesToShow / 2);
        }
        return Array.from({length: endPage - startPage + 1}, (_, i) => startPage + i);
    }

    setCurriculumPage(page: number): void {
        this.curriculumCurrentPage = page;
        this.saveProfileDetailsState();
    }

    firstCurriculumPage(): void {
        this.curriculumCurrentPage = 1;
        this.saveProfileDetailsState();
    }

    lastCurriculumPage(): void {
        this.curriculumCurrentPage = this.curriculumTotalPages;
        this.saveProfileDetailsState();
    }

    previousCurriculumPage(): void {
        if (this.curriculumCurrentPage > 1) {
            this.curriculumCurrentPage--;
            this.saveProfileDetailsState();
        }
    }

    nextCurriculumPage(): void {
        if (this.curriculumCurrentPage < this.curriculumTotalPages) {
            this.curriculumCurrentPage++;
            this.saveProfileDetailsState();
        }
    }

    getCurriculumPercentage(item: any): string {
        if (item.content_type == '1') {
            return '-';
        }
        if (item.percentage) {
            return item.percentage + '%';
        }
        if (item.obtained_score != null && item.total_score != null && item.total_score !== '') {
            return `${item.obtained_score}/${item.total_score}`;
        }
        return '-';
    }

    canViewCurriculumDetail(item: any): boolean {
        return item.content_type != '1' && !!item.student_content_id;
    }

    private enrichCurriculumItems(items: any[]): void {
        items.forEach((item) => {
            item.overdueStatus = true;
            if (item.overdue < 0) {
                item.overdueStatus = false;
                item.overdue = Math.abs(item.overdue);
            }
        });
    }

    private buildCurriculumClassFilterOptions(items: any[]): void {
        const classMap = new Map<string, string>();
        items.forEach((item) => {
            if (item.class_id != null && item.class_id !== '' && item.class_name) {
                classMap.set(String(item.class_id), item.class_name);
            }
        });
        this.curriculumClassFilterOptions = [
            {class_id: '', class_name: 'All Class'},
            ...Array.from(classMap.entries())
                .map(([class_id, class_name]) => ({class_id, class_name}))
                .sort((a, b) => a.class_name.localeCompare(b.class_name))
        ];
    }

    curriculumStatusLabel(item: any): string {
        if (item.content_type == '1') {
            return 'Available';
        }
        const status = item.student_content_status;
        if (status == 1 && item.overdueStatus) {
            return 'Not started';
        }
        if (status == 1 && !item.overdueStatus) {
            return 'Overdue';
        }
        if (status == 2) {
            return 'In-Progress';
        }
        if (status == '3') {
            return 'Score Released';
        }
        if (status == '4' || status == '6') {
            return 'Correction Pending';
        }
        if (status == '5') {
            return 'Correction Completed';
        }
        return '-';
    }

    curriculumStatusBadgeClass(item: any): string {
        if (item.content_type == '1') {
            return 'badge-muted';
        }
        const status = item.student_content_status;
        if (status == 1 && item.overdueStatus) {
            return 'badge-muted';
        }
        if (status == 1 && !item.overdueStatus) {
            return 'badge-danger';
        }
        if (status == 2) {
            return 'badge-warning';
        }
        if (status == '3') {
            return 'badge-primary';
        }
        if (status == '4' || status == '6') {
            return 'badge-info';
        }
        if (status == '5') {
            return 'badge-green';
        }
        return 'badge-muted';
    }

    contentTypeBadgeClass(type: string): string {
        if (type === '1') {
            return 'badge-green';
        }
        if (type === '2') {
            return 'badge-warning';
        }
        if (type === '3') {
            return 'badge-primary';
        }
        return 'badge-primary';
    }

    reportsContentTypeBadgeClass(type: string): string {
        if (type === '3') {
            return 'badge-report-assessment';
        }
        return this.contentTypeBadgeClass(type);
    }

    communicationContentTypeLabel(type: string): string {
        if (type === '1') {
            return 'Resource';
        }
        if (type === '2') {
            return 'Assignment';
        }
        if (type === '3') {
            return 'Assessment';
        }
        return 'Assessment';
    }

    getCommunicationClassDate(msg: any): string {
        const dateValue = msg?.class_date || msg?.date || msg?.schedule_date;
        if (dateValue && dateValue !== '0000-00-00') {
            return this.datePipe.transform(dateValue, 'dd-MM-yyyy') || '-';
        }
        if (msg?.class_name) {
            return msg.class_name;
        }
        return '-';
    }

    closeOverAll(): void {
        this.modalRef.close('viewoveralldetails');
    }

    getStudentFullDetail(item: any): void {
        this.classData = item;
        this.modalRef = this.modalService.open(this.viewoveralldetails, {size: 'xl', windowClass: 'reportcardContent'});
    }

    addMakeUpClass(event: any): void {
        event.absent_date = {
            isRange: false,
            singleDate: {jsDate: new Date(event.date)}
        };
        event.student_name = this.studentProfileDetails[0]?.first_name + ' ' + this.studentProfileDetails[0]?.last_name;
        this.auth.setSessionData('makeUpClass_calledFrom', 'profile');
        this.auth.setSessionData('classSelected_makeUp', JSON.stringify(event));
        this.auth.setSessionData('studentSelected_makeUp', event.student_id);
        this.router.navigate(['/schedule/schedule-page']);
    }

    voidFunctionCalled(data: any, index: number): void {
        this.voidClassData = data;
        this.voidClassIndex = index;
        this.modalRef = this.modalService.open(this.voidClass);
    }

    deleteStudentList(): void {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            class_id: this.voidClassData.makeup_class_id,
            student_id: this.studentId,
            make_up: '1'
        };
        this.classes.deleteStudentList(data).subscribe(
            (successData) => this.deleteStudentListSuccess(successData),
            (error) => console.log(error)
        );
    }

    deleteStudentListSuccess(successData: any): void {
        if (successData.IsSuccess) {
            this.modalRef.close();
            this.toastr.success(successData.ResponseObject);
            this.attendanceList('');
        } else {
            this.toastr.error(successData.ResponseObject);
        }
    }

    studentDetails() {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            type: 'list',
            school_id: this.auth.getSessionData('school_id'),
            student_id: this.studentId
        };
        this.student.getStudentList(data).subscribe((successData) => {
                this.studentProfileDetailsSuccess(successData);
            },
            (error) => {
                this.serviceCalled = false;
                console.error(error, 'error_studentDetails');
            });
    }

    studentProfileDetailsSuccess(successData) {
        console.log(successData, 'successData');
        this.studentProfileDetails = successData.ResponseObject;
        this.serviceCalled = true;
        this.gradeList();
        this.studentFullClassList();
        console.log(this.studentProfileDetails, 'studentProfileDetails');
    }

    gradeList() {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            type: 'active'
        };
        this.student.getgradeList(data).subscribe((successData: any) => {
                console.log(successData, 'successData');
                if (successData.IsSuccess) {
                    this.gradeData = successData.ResponseObject;
                    this.gradeData.forEach((items) => {
                        if (items.grade_id == this.studentProfileDetails[0].grade_id) {
                            this.studentProfileDetails[0].grade_name = items.grade_name;
                        }
                    });
                }
            },
            (error) => {
                console.error(error, 'error');
            });
    }

    studentNotifyStatus(classData, notifyType) {
        const payload = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            student_id: this.studentId,
            class_id: classData.class_id,
            notify_status: notifyType
        };
        this.student.studentNotifyStatus(payload).subscribe((successData) => {
                this.studentFullClassList();
            },
            (error) => {
                console.error(error, 'studentFullClassList');
            });
    }

    studentFullClassList() {
        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            school_id: this.auth.getSessionData('school_id'),
            student_id: this.studentId
        };
        this.student.getAllClassOfStudent(data).subscribe((successData) => {
                this.studentFullClassListSuccess(successData);
            },
            (error) => {
                console.error(error, 'studentFullClassList');
            });
    }

    studentFullClassListSuccess(successData) {
        if (successData.IsSuccess) {
            this.studentFullClassListData = successData.ResponseObject;
            this.classList = [];
            this.studentFullClassListData.forEach((items) => {
                items.showText = true;
                this.classList.push(items);
            });
            this.classList.unshift({class_id: '', class_name: 'All Class'});
            this.attendanceList(this.selectedClassId || '');
        }
    }

    attendanceFilter(value) {
        this.selectedClassId = value ? value.class_id : '';
        this.saveProfileDetailsState();
        this.attendanceList(this.selectedClassId);
    }

    attendanceList(classId) {

        const data = {
            platform: 'web',
            role_id: this.auth.getRoleId(),
            user_id: this.auth.getUserId(),
            student_id: this.studentId,
            class_id: classId
        };
        this.student.studentAttendanceList(data).subscribe((successData) => {
                this.attendanceListSuccess(successData);
            },
            (error) => {
                console.error(error, 'AttendanceList');
            });
    }

    attendanceListSuccess(successData) {
        console.log(successData, 'successData');
        if (successData.IsSuccess) {
            this.attendanceListData = successData.ResponseObject;
            this.attendanceListData.forEach((student: any) => {
                if (student.makeup_class_id != '') {
                    const currentDate = new Date(new Date().toLocaleString('en-US', { timeZone: timeZone.location }));
                    const makeupDate = new Date(student.makeup_class_date);
                    student.allow_void_class = currentDate < makeupDate;
                    console.log(student.allow_void_class, 'student.allow_void_class');
                } else {
                    student.allow_void_class = false;
                }
            });
        }
    }
}
